import { render, staticRenderFns } from "./ProfileInfoIcon.vue?vue&type=template&id=e40110b2&scoped=true"
import script from "./ProfileInfoIcon.vue?vue&type=script&lang=ts"
export * from "./ProfileInfoIcon.vue?vue&type=script&lang=ts"
import style0 from "./ProfileInfoIcon.vue?vue&type=style&index=0&id=e40110b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40110b2",
  null
  
)

export default component.exports